/* eslint dot-notation:0 */
(function(angular) {
    'use strict';

    angular.module('um.roles').controller('roles.controller', rolesCtrl);

    rolesCtrl.$inject = ['$scope', '$state', '$modal', '$timeout', '$translate', 'rolesService',
        'GUM_CONST', 'trackingService', 'wtNotifications', 'featureFlags', '$q', 'usersService',
        'categoriesService', '$stateParams'];

    function rolesCtrl($scope, $state, $modal, $timeout, $translate, rolesService, GUM_CONST,
        trackingService, wtNotifications, featureFlags, $q, usersService, categoriesService, $stateParams) {
        var that = this;

        this.$onInit = function() {
            that.isFetching = true;
            
            const promises = [
                rolesService.getAllRoles(),
                usersService.getAllUsers(),
                rolesService.getServiceAccounts(),
                categoriesService.getAllCategories()
            ];

            if ($stateParams.roleId) {
                promises.push(rolesService.getRoleById($stateParams.roleId));
                promises.push(rolesService.getRoleUsers($stateParams.roleId));
                promises.push(rolesService.getRoleRAR($stateParams.roleId));
                promises.push(rolesService.getRoleConfigPermissions($stateParams.roleId, 'custom_elements'));
            } else {
                that.role = {};
                that.roleUsers = [];
                that.reportAccessRights = {accessLevel: 'no', cats: []};
                that.hasCustomElementsPermissions = false;
            }

            return $q.all(promises)
                .then(function(values) {
                    that.roles = _.nth(values, 0) || [];
                    that.users = _.nth(values, 1) || [];
                    that.allServiceAccounts = _.nth(values, 2) || [];
                    that.categories = _.nth(values, 3) || [];

                    if ($stateParams.roleId) {
                        that.role = _.nth(values, 4) || {};
                        that.roleUsers = _.nth(values, 5) || {};
                        that.reportAccessRights = _.nth(values, 6) || {};
                        that.hasCustomElementsPermissions = (_.nth(values, 7) || {}).accessLevel === 'full';
                    }

                    if (that.role.accessLevel) {
                        // TODO translate function, since the access level shall be saved as string
                        that.selectedRarAccesslevel = that.role.accessLevel;
                    } else {
                        that.selectedRarAccesslevel = 0;
                    }

                    that.initializeView();

                    that.isFetching = false;
                });
        };

        /**
         * flag for saveTempAccessMenu on click or not
         * @type {boolean}
         */
        that.touchedOnce = false;

        /**
         * flag to enable/disable edit mode
         * @type {boolean}
         */
        that.editLock = false;

        /**
         * define the initially open panel
         * @type {boolean}
         */
        that.detailsOpen = false;

        /**
         * flag for the products tab template
         * if true, the 'select role for tag integration is shown'
         * @type {boolean}
         */
        that.hasActiveTagIntegration = false;

        /**
         * array holding all required services information
         * @type {Array}
         */
        that.services = GUM_CONST.services;

        /**
         * array holding all serviceAccounts
         */
        that.serviceAccounts = [];

        /**
         * the access menu is not fully loaded
         * @type {boolean}
         */
        that.stillLoading = false;

        /**
         * object temp save of the custom menu access
         */
        that.tempServiceRights = null;

        /**
         * is at least one account assigned
         * @type {boolean}
         */
        that.noAccountsAssigned = true;

        /**
         * list of selected actegories for report access rights
         * @type {array}
         */
        that.selectedCategories = [];

        /**
         * is admin role or not
         * @type {boolean}
         */
        that.isAdmin = false;

        /**
         * is DCPM role or not
         * @type {boolean}
         */
        that.isDpcm = false;

        /**
         * is disabled for editing or not
         * @type {boolean}
         */
        that.isDisabled = false;

        /**
         * Is the custom metric editor enabled for this account
         * @type {boolean}
         */
        that.enableCustomMetricEditor = (featureFlags.indexOf('enableCustomMetricEditor') >= 0);

        /**
         * handle panel states to support validation
         * @type {{details: {touched: boolean, open: boolean}, accounts: {touched: boolean, open: boolean}, services: {touched: boolean, open: boolean}, users: {touched: boolean, open: boolean}}}
         */
        that.panels = {
            details: {
                touched: false,
                open: true
            },
            accounts: {
                touched: false,
                open: false
            },
            services: {
                touched: false,
                open: false
            },
            users: {
                touched: false,
                open: false
            }
        };

        /**
         * access level definition
         * @type {[{name: String, height: int, left: String}]}
         */
        that.rarAccessLevel = [
            {
                name: 'ROLE_RAR_LEVEL_VIEW',
                left: '0%'
            }, {
                name: 'ROLE_RAR_LEVEL_CREATE',
                left: '20%'
            }, {
                name: 'ROLE_RAR_LEVEL_SHARE',
                left: '40%'
            }, {
                name: 'ROLE_RAR_LEVEL_EDIT_DELETE',
                left: '60%'
            }, {
                name: 'ROLE_RAR_LEVEL_FULL_ACCESS',
                left: '80%'
            }
        ];

        // allocator settings: accounts
        that.accountSourceList = [];
        that.accountTargetList = [];

        that.accountAllocatorOptions = {
            leftListHeading: 'AVAILABLE_ACCOUNTS',
            rightListHeading: 'ASSIGNED_ACCOUNTS',
            addButtonText: '',
            removeButtonText: '',
            searchPlaceholder: 'SEARCH',
            moveAllButton: false,
            orderBy: 'name',
            locked: false,
            identifier: 'accountId',
            filterFunction: function(element, value) {
                return Boolean(element.name.toLowerCase().match(value.toLowerCase()));
            },
            filterBar: {
                target: true,
                source: true
            },
            clickHandlers: {
                remove: null, // set later in the code
                add: null
            },
            columns: [
                {title: '', key: 'name'}
            ],
            hideHeader: true,
            boxDimensions: {
                height: '200px'
            }
        };

        /**
         * Initialize the view, pre-populate accounts
         */
        that.initializeView = function() {
            that.prepareServiceAccounts();
            that.prepareRAROnLoad(that.reportAccessRights);
            that.initializeSlider();

            if (that.role.id) {
                if (that.role.name === GUM_CONST.adminRole) {
                    that.isAdmin = true;
                    that.usersOpen = true;
                }

                if (that.role.name === GUM_CONST.dpcmRole) {
                    that.isDpcm = true;
                }

                that.isDisabled = that.isAdmin || that.isDpcm;

                if (!that.role.serviceAccounts) {
                    that.role.serviceAccounts = [];
                }

                // pre-populate accounts & checkBoxes
                if (that.role && that.role.serviceAccounts) {
                    that.allocateServiceAccounts();

                    if (that.accountSourceList) {
                        that.setHasActiveTagIntegration();
                    }

                    if (that.accountTargetList) {
                        that.addAccountsFromAccountList(that.accountTargetList);
                    }
                }
            } else {
                that.detailsOpen = true;
            }
        };

        /**
         * Initialize the Report Access Level slider
         */
        that.initializeSlider = function() {
            $timeout(function() {
                that.slider = new Slider('#rarAccessRights', {
                    formatter: function(value) {
                        that.selectedRarAccesslevel = value;
                    }
                });

                that.slider.on('slide', function(slideEvt) {
                    that.selectedRarAccesslevel = slideEvt.value;
                });
            }, 0);
        };

        /**
         * adds a single account
         * @param {object} account
         */
        that.addAccount = function(account) {
            if (!account || !(account.accountId)) {
                return;
            }
            that.serviceAccounts = _.union(that.serviceAccounts, [account]);
            if (that.noAccountsAssigned && that.serviceAccounts.length > 0) {
                that.noAccountsAssigned = false;
            }
        };

        /**
         * add accounts callback for allocator module
         * @param {array} accounts
         */
        that.addAccountsFromAccountList = function(accounts) {
            _.each(accounts, function(account) {
                that.addAccount(account);
                delete account.selected;
            });
            that.setHasActiveTagIntegration();
        };

        /**
         * remove callback for allocator module
         * @param {array} items
         */
        that.onRemoveAccounts = function(items) {
            var idsToRemove = _.map(items, 'accountId');
            _.remove(that.serviceAccounts, function(account) {
                return _.includes(idsToRemove, account.accountId);
            });
            if (!that.noAccountsAssigned && that.serviceAccounts.length === 0) {
                that.noAccountsAssigned = true;
            }
            that.setHasActiveTagIntegration();
        };

        // provide clickHandlers to allocator options
        that.accountAllocatorOptions.clickHandlers.add = that.addAccountsFromAccountList;
        that.accountAllocatorOptions.clickHandlers.remove = that.onRemoveAccounts;

        that.userAllocatorOptions = {
            leftListHeading: 'AVAILABLE_USERS',
            rightListHeading: 'ASSIGNED_USERS',
            addButtonText: '',
            removeButtonText: '',
            searchPlaceholder: 'SEARCH',
            orderBy: 'loginName',
            locked: false,
            identifier: 'id',
            filterFunction: function(element, value) {
                // filters the loginName, not taking the companyPrefix into account
                return Boolean(element.loginName.replace(/^([^.]+)./, '').toLowerCase().match(value.toLowerCase()));
            },
            filterBar: {
                target: true,
                source: true
            },
            clickHandlers: {
                remove: null, // set later in the code
                add: null
            },
            decorators: { // remove the company prefix from the loginName
                loginName: function(name) {
                    return name.replace(/^([^.]+)./, '');
                }
            },
            columns: [
                {title: '', key: 'loginName'}
            ],
            hideHeader: true,
            boxDimensions: {
                height: '200px'
            }
        };

        // allocator settings: categories
        that.categoriesAllocatorOptions = {
            leftListHeading: 'ROLE_AVAILABLE_CATEGORIES',
            rightListHeading: 'ROLE_ASSIGNED_CATEGORIES',
            addButtonText: '',
            removeButtonText: '',
            searchPlaceholder: 'SEARCH',
            orderBy: 'name',
            locked: false,
            identifier: 'name',
            filterFunction: function(element, value) {
                return Boolean(element.name.toLowerCase().match(value.toLowerCase()));
            },
            filterBar: {
                target: true,
                source: true
            },
            clickHandlers: {
                remove: null, // set later in the code
                add: null
            },
            columns: [
                {title: '', key: 'name'}
            ],
            hideHeader: true,
            boxDimensions: {
                height: '200px'
            }
        };

        /**
         * traverses the serviceAccounts list to a list of accounts with an array of services
         * used by the allocator module
         */
        that.prepareServiceAccounts = function() {
            var accounts = [];

            for (var i = 0; i < that.allServiceAccounts.length; i++) {
                var serviceAccount = that.allServiceAccounts[i];

                var service = {
                    id: serviceAccount.id,
                    name: serviceAccount.service && serviceAccount.service.name,
                    enabled: serviceAccount.enabled,
                    active: false
                };

                var account = _.find(accounts, {accountId: serviceAccount.account.accountId});

                if (!account) {
                    account = {
                        name: serviceAccount.account.name,
                        accountId: serviceAccount.account.accountId,
                        services: {}
                    };
                    accounts.push(account);
                }

                account.services[service.name] = service;
            }

            that.accountSourceList = accounts;
        };

        that.allocateServiceAccounts = function allocateServiceAccounts() {
            var selectedAccounts = [];

            _.each(that.accountSourceList, function(account) {
                _.each(account.services, function(service) {
                    if (_.find(that.role.serviceAccounts,
                        function(serviceAccount) {
                            if (serviceAccount.id) {
                                return (serviceAccount.id === service.id && service.enabled);
                            }

                            return (serviceAccount.account.accountId === account.accountId
                                && serviceAccount.service.name === service.name);
                        })) {
                        service.active = true;
                        selectedAccounts.push(account.accountId);
                    }
                });
            });

            if (selectedAccounts.length) {
                selectedAccounts = _.uniq(selectedAccounts);
                _.each(selectedAccounts, function(accountId) {
                    // initiate a not referenced copy of source list
                    var tempSourceList = angular.copy(that.accountSourceList);

                    that.accountTargetList = that.accountTargetList.concat(_.remove(tempSourceList,
                        {accountId: accountId}));
                    that.serviceAccounts = that.accountTargetList;

                    if (that.accountTargetList.length > 0) {
                        that.noAccountsAssigned = false;
                    }
                });
            }
        };

        /**
         * check if there is an active TI account available
         * invoked only when products tab is clicked
         */
        that.setHasActiveTagIntegration = function() {
            that.hasActiveTagIntegration = _.find(that.serviceAccounts, function(account) {
                return _.find(account.services, function(service) {
                    return service.name === GUM_CONST.tagIntegrationId && service.enabled;
                });
            });
        };

        that.checkRoleNameExists = function(roleObject) {
            that.nameExists = rolesService.roleNameExists(roleObject);
        };

        /**
         * collects the ids of each selected service and adds it as simple array to the isAdmin object
         * to be send to backend
         */
        var addServicesToRole = function() {
            var activeServices = [];

            for (var i = 0; i < that.serviceAccounts.length; i++) {
                var account = that.serviceAccounts[i];

                for (var j in account.services) {
                    if (account.services[j].active) {
                        activeServices.push({id: account.services[j].id});
                    }
                }
            }

            that.role.serviceAccounts = _.uniq(activeServices);

            // finally add the TI serviceAccount id if set.
            // If there are more than one available, the first found is transmitted
            if (that.hasActiveTagIntegration && that.hasActiveTagIntegration.active) {
                that.role.serviceAccounts.push({
                    id: that.hasActiveTagIntegration.services[GUM_CONST.tagIntegrationId].id
                });
            }
        };

        /**
         * transforms the selected data of the customer
         * @returns {object} rar
         */
        that.prepareRARForSave = function prepareRARForSave() {
            var accessLevel = 'no';
            var selectedCats = [];

            if (that.rarActivated) {
                if (that.selectedRarAccesslevel < (that.rarAccessLevel.length - 1)) {
                    for (var i = 0, l = that.selectedCategories.length; i < l; i++) {
                        selectedCats.push(that.selectedCategories[i].id);
                    }
                }

                for (var j in GUM_CONST.rarAccessLevels) {
                    if (GUM_CONST.rarAccessLevels[j] === (that.selectedRarAccesslevel + 1)) {
                        accessLevel = j;
                        break;
                    }
                }
            }

            var rar = {
                accessLevel: accessLevel,
                cats: selectedCats
            };

            return rar;
        };

        /**
         * transforms the selected data of the customer
         * @param {object} rar
         */
        that.prepareRAROnLoad = function prepareRAROnLoad(rar) {
            var accessLevelNumber = GUM_CONST.rarAccessLevels[rar.accessLevel];

            if (accessLevelNumber > 0) {
                that.rarActivated = true;
                that.selectedRarAccesslevel = accessLevelNumber - 1; // list of access levels hasn't a 'no' entry

                for (var i = 0, l = rar.cats.length; i < l; i++) {
                    var index = _.findIndex(that.categories, {id: rar.cats[i]});
                    if (index > -1 && that.selectedRarAccesslevel < (that.rarAccessLevel.length - 1)) {
                        that.selectedCategories.push(that.categories[index]);
                    }
                }
            } else {
                that.rarActivated = false;
                that.selectedRarAccesslevel = 0;
                that.selectedCategories = [];
            }
        };

        that.prepareMenuAccessRights = function prepareMenuAccessRights(menu) {
            if (menu.childs) {
                for (var i = menu.childs.length - 1; i >= 0; i--) {
                    if (menu.childs[i].selected !== 0) {
                        if (menu.childs[i].partial) {
                            that.prepareMenuAccessRights(menu.childs[i]);
                        } else {
                            delete menu.childs[i].childs;
                        }
                    } else {
                        menu.childs.splice(i, 1);
                    }
                }
            }
        };

        /**
         * Collect all the rights.
         * @returns {array} roleServicesRights
         */
        var getRightsOfRole = function getRightsOfRole() {
            var roleServicesRights = [];

            for (var i = 0, l = that.services.length; i < l; i++) {
                if (that.services[i].rights) {
                    var serviceRights = {};
                    serviceRights.id = that.services[i].id;
                    serviceRights.rights = {};
                    serviceRights.rights.access = that.accessLevelTranslate(that.services[i].rights.access, true);

                    if (serviceRights.rights.access === 'custom' && that.services[i].levels) {
                        // Add menu access rights
                        serviceRights.rights.menu = angular.copy(that.services[i].levels[0]);
                        that.prepareMenuAccessRights(serviceRights.rights.menu);
                    }

                    roleServicesRights.push(serviceRights);
                }
            }

            return roleServicesRights;
        };

        /**
         * Updates or saves the role. If there are accounts assigned, which are not configured,
         * there will be a confirmation dialog. If this dialog gets confirmed, or there are no
         * not configured accounts in the first place, the function save() gets called
         */
        that.checkSave = function checkSave() {
            var notConfiguredAccount = [];
            _.forEach(that.serviceAccounts, function(obj) {
                var count = 0;

                _.forEach(obj.services, function(innerObj) {
                    if (innerObj.active) {
                        return;
                    }
                    count++;
                });

                if (_.size(obj.services) <= count) {
                    notConfiguredAccount.push(obj);
                }
            });

            if (notConfiguredAccount.length) {
                $scope.saveModalInstance = $modal.open({
                    templateUrl: 'template/modal/confirmationDialog.html',
                    controller: 'roles.confirmation.controller',
                    resolve: {
                        notConfiguredAccount: function() {
                            return notConfiguredAccount;
                        }
                    }
                });

                $scope.saveModalInstance.result
                    .then(function() {
                        that.save();
                    })
                    .catch(function() {
                        // here could something be done
                    });
            } else {
                that.save();
            }
        };

        that.save = function save() {
            addServicesToRole();
            var rights = getRightsOfRole();
            var permissions = that.prepareRARForSave();
            var customElementsPermissions = {
                accessLevel: that.hasCustomElementsPermissions ? 'full' : 'no'
            };

            if (that.role.id) {
                trackingService.action('role.update');
                rolesService.updateRole(that.role, that.roleUsers, rights, permissions, customElementsPermissions)
                    .then(function(response) {
                        $state.go('main.roles.overview')
                            .then(() => {
                                wtNotifications.success(
                                    $translate.instant('MSG.ROLE_UPDATE_SUCCESS', {roleName: response.name}, '', '')
                                );
                            });
                    })
                    .catch(function(err) {
                        const errorMessage = _.has(err, 'message') || err;
                        if (errorMessage) {
                            wtNotifications.error(errorMessage.toUpperCase());
                        }
                    });
            } else {
                trackingService.action('role.create');
                rolesService.createRole(that.role, that.roleUsers, rights, permissions, customElementsPermissions)
                    .then(function(response) {
                        $state.go('main.roles.overview')
                            .then(() => {
                                wtNotifications.success(
                                    $translate.instant('MSG.ROLE_CREATE_SUCCESS', {roleName: response.name}, '', '')
                                );
                            });
                    })
                    .catch(function(err) {
                        if (_.has(err, 'message') && !_.isUndefined(err.message)) {
                            wtNotifications.error(err.message.toUpperCase());
                        }
                    });
            }
        };

        const ModalController = ['that', '$modalInstance',
            function(that, $modalInstance) {
                that.closeModal = function() {
                    $modalInstance.dismiss('cancel');
                };

                that.goToRoles = function() {
                    $modalInstance.dismiss('cancel');
                    $state.go('main.roles.overview');
                };
            }];

        that.cancelCreate = function() {
            $scope.modalInstance = $modal.open({
                templateUrl: 'template/modal/assureCancelDirtyForm.html',
                controller: ModalController,
                resolve: {}
            });
        };
        // handlers for the checkbox "selectAll" helpers
        that.selectRow = function(account, check) {
            _.each(account.services, function(service) {
                if (service.enabled && service.name !== GUM_CONST.tagIntegrationId) {
                    service.active = check;
                }
            });
        };

        that.selectColumn = function(service, check) {
            _.each(that.serviceAccounts, function(account) {
                if (account.services[service.id] && account.services[service.id].enabled) {
                    account.services[service.id].active = check;
                }
            });
        };

        that.selectAll = function(what) {
            if (!what) { // select everything
                for (var i = 0; i < that.serviceAccounts.length; i++) {
                    var account = that.serviceAccounts[i];
                    that.selectedServices.byAccount[account.accountId] = that.selectedServices.all;
                    that.selectRow(account, that.selectedServices.all);
                }

                for (var j = 0; j < GUM_CONST.services.length; j++) {
                    var service = GUM_CONST.services[j];
                    that.selectedServices.byService[service.id] = that.selectedServices.all;
                }
            } else {
                if (what.account) { // check row
                    that.selectRow(what.account, that.selectedServices.byAccount[what.account.accountId]);
                }

                if (what.service) { // check column
                    that.selectColumn(what.service, that.selectedServices.byService[what.service.id]);
                }
            }
        };

        that.selectedServices = {
            all: false,
            byAccount: {},
            byService: {}
        };

        // RIGHTS MANAGEMENT TODO: put in seperate controller???

        that.titles = ['TOP_LEVEL', 'SECOND_LEVEL', 'THIRD_LEVEL'];

        that.getAccessLevel = function getAccessLevel(service) {
            return (function() {
                if (that.role.id) {
                    rolesService.getRoleRights(that.role.id, service.id)
                        .then(function(rights) {
                            service.rights = {
                                access: GUM_CONST.accessLevels[rights.access]
                                // blacklist: rights.blacklist || {}
                            };
                            that.accessRight = rights;
                        })
                        .catch(function() {
                            // TODO: error case
                        });
                } else {
                    service.rights = {
                        access: 1
                        // blacklist: {}
                    };
                    that.accessRight = {
                        access: 'full'
                    };
                }
            })(service);
        };

        /*
         * get the access menu for all the accounts selected on tab switch to 'Rights Management'
         */
        that.getAccessRights = function getAccessRights() {
            that.touchedOnce = true;

            // Initialization of the Menu Access Rights and Dimensions and Metrics Rights
            that.services.forEach(function(service) {
                if (service.rights) {
                    // initialize access levels for each service
                    that.getAccessLevel(service);
                }
            });

            if (!that.isDisabled) {
                // Create an array with all the accountIDs that are selected by the user
                var accountIds = [];
                for (var i = 0; i < that.serviceAccounts.length; i++) {
                    accountIds.push(that.serviceAccounts[i].accountId);
                }

                // get all access menus by API
                if (accountIds.length > 0) {
                    // show spinner while loading the menu
                    that.stillLoading = true;

                    rolesService.getAccessMenu(accountIds)
                        .then(function(menus) {
                            var allMenus = that.prepareMenusForMerge(menus);
                            var formattedMenu = [];
                            for (var j = 0, l = allMenus.length; j < l; j++) {
                                formattedMenu = formattedMenu.concat(that.formatMenu(allMenus[j]));
                            }
                            var t = null;
                            if (that.accessRight.menu) {
                                t = that.accessRight.menu.t || null;
                            } else if (that.accessRight.access === 'full') {
                                t = 'as'; // as: all selected
                            }
                            that.finalMenu = {
                                t: t, // indicates if all elements are selected
                                childs: that.mergeMenu([], formattedMenu)
                            };

                            that.buildAccessMenu();

                            that.stillLoading = false;
                        })
                        .catch(function() {
                            // TODO
                            that.stillLoading = false;
                        });
                }
            }
        };

        that.saveTempAccessMenu = function saveTempAccessMenu() {
            that.tempServiceRights = getRightsOfRole();
        };

        that.prepareMenusForMerge = function(menus) {
            var preparedMenus = [];

            for (var i = 0, l = menus.length; i < l; i++) {
                if (menus[i].menu && menus[i].menu.childEntries) {
                    preparedMenus.push(menus[i].menu.childEntries);
                }
            }

            return preparedMenus;
        };

        that.formatMenu = function(menu) {
            var tmp = [];
            for (var i = 0, l = menu.length; i < l; i++) {
                var obj = {};
                tmp.push(obj);

                obj.id = menu[i].id;
                obj.name = menu[i].title;

                if (menu[i].childEntries.length > 0) {
                    obj.childs = that.formatMenu(menu[i].childEntries);
                }

                if (i === l - 1) {
                    return tmp;
                }
            }
            return tmp;
        };

        that.mergeMenu = function(finalMenu, menu) {
            for (var i = 0, l = menu.length; i < l; i++) {
                var index = _.findIndex(finalMenu, {id: menu[i].id, name: menu[i].name});
                if (index === -1) {
                    finalMenu.push(menu[i]);
                } else if (!finalMenu[index].childs && menu[i].childs) {
                    finalMenu[index].childs = menu[i].childs;
                } else if (finalMenu[index].childs && menu[i].childs) {
                    that.mergeMenu(finalMenu[index].childs, menu[i].childs);
                }
            }
            return finalMenu;
        };

        /**
         * Go into the next level of the Access Menu.
         * @param {object} service
         * @param {array} level
         * @param {int} index
         */
        that.nextLevel = function(service, level, index) {
            if (!service.levels) {
                service.levels = [];
            }

            service.levels.splice(index, service.levels.length - index, level);
        };

        /**
         * Access Menu Rights: toggle all menuitems and it's submenuitems of a specific level. (recursive)
         * @param {object} service
         * @param {object} level (1 to 3)
         * @param {boolean} status (true or false)
         */
        var toggleAllChilds = function(service, level, status) {
            if (level.childs) {
                level.selected = status ? level.childs.length : 0;
                level.selectedAnalyses = status ? level.totalAnalyses : 0;

                for (var i = 0, l = level.childs.length; i < l; i++) {
                    level.childs[i].partial = false;
                    toggleAllChilds(service, level.childs[i], status);
                }
            } else {
                level.selected = status ? -1 : 0;
                level.selectedAnalyses = status ? 1 : 0;
            }
        };

        /**
         * calculates max number of analyses in Access Menu Rights (recursive)
         * @param {object} level
         */
        var calculateTotalAnalyses = function calculateTotalAnalyses(level) {
            level.totalAnalyses = 0;

            if (level.childs) {
                for (var i = 0; i < level.childs.length; i++) {
                    calculateTotalAnalyses(level.childs[i]);
                    level.totalAnalyses += level.childs[i].totalAnalyses;
                }
            } else {
                level.totalAnalyses = 1;
            }
        };

        /**
         * Access Menu Rights: Function make sure the 'Select All' boxes are displayed correctly.
         * @param {object} levels
         */
        var checkIfAllOrNoneSelected = function(levels) {
            var partial = false;

            for (var j = levels.length - 1; j >= 0; j--) {
                if (levels[j].childs) {
                    var selectedChilds = 0;
                    var countSelectedAnalyses = 0;

                    const k = levels[j].childs.length;
                    for (var i = 0; i < k; i++) {
                        var child = levels[j].childs[i];

                        if (child.partial) {
                            partial = true;
                        }

                        if (child.selected !== 0) {
                            selectedChilds++;
                            countSelectedAnalyses += child.selectedAnalyses;
                        }
                    }
                    levels[j].selected = selectedChilds;
                    levels[j].selectedAnalyses = countSelectedAnalyses;
                    levels[j].partial = partial || (selectedChilds > 0 && selectedChilds < k);
                }
            }
        };

        /**
         * Initializes the Access Menu with the data you got from the role (recursive)
         * @param {object} service
         * @param {object} menu
         * @param {object} rights
         */
        that.initializeMenu = function initializeMenu(service, menu, rights) {
            if (rights && rights.hasOwnProperty('t') && rights.t === 'as') {
                that.toggleAll(service, that.finalMenu, true);
            } else {
                for (var i = 0, l = rights.childs.length; i < l; i++) {
                    var child = _.find(menu.childs, {id: rights.childs[i].id});

                    if (child) {
                        if (child.childs) {
                            if (rights.childs[i].childs) {
                                child.partial = true;
                                that.initializeMenu(service, child, rights.childs[i]);
                            } else {
                                child.selected = menu.childs[i].length;
                                toggleAllChilds(service, child, true);
                            }
                        } else {
                            child.selected = -1;
                            child.selectedAnalyses = 1;
                        }

                        if (typeof menu.selected === 'undefined') {
                            menu.selected = 0;
                        }
                        menu.selected++;

                        if (typeof menu.selectedAnalyses === 'undefined') {
                            menu.selectedAnalyses = 0;
                        }
                        menu.selectedAnalyses += child.selectedAnalyses;
                    }
                }
            }
        };

        /**
         * Access Menu Rights: toggle all menu items specific level & check the 'Select All' boxes.
         * @param {object} service
         * @param {object} level (1 to 3)
         * @param {boolean} status (true or false)
         */
        that.toggleAll = function(service, level, status) {
            trackingService.action('role.change_menu_access');

            toggleAllChilds(service, level, status);
            checkIfAllOrNoneSelected(service.levels);

            if (that.finalMenu.selectedAnalyses === that.finalMenu.totalAnalyses) {
                that.finalMenu.t = 'as';
            } else {
                that.finalMenu.t = null;
            }
        };

        that.buildAccessMenu = function buildAccessMenu() {
            for (var i = 0, l = that.services.length; i < l; i++) {
                if (that.services[i].rights) {
                    // Initialize levels for menu access rights;
                    if (that.role.id) {
                        (function(service) {
                            that.nextLevel(service, that.finalMenu, 0);
                            calculateTotalAnalyses(that.finalMenu);

                            if (service.rights.access === GUM_CONST.accessLevels.custom) {
                                toggleAllChilds(service, that.finalMenu, false);

                                // load temp rights if there are any
                                if (that.tempServiceRights) {
                                    that.initializeMenu(service, that.finalMenu,
                                        angular.copy(that.tempServiceRights[0].rights.menu));
                                } else {
                                    that.initializeMenu(service, that.finalMenu, that.accessRight.menu);
                                }
                            } else {
                                toggleAllChilds(service, that.finalMenu, true);
                            }

                            checkIfAllOrNoneSelected(service.levels);
                        })(that.services[i]);
                    } else {
                        (function(service) {
                            service.rights = {
                                access: 1
                            };

                            that.nextLevel(service, that.finalMenu, 0);
                            calculateTotalAnalyses(that.finalMenu);
                            that.toggleAll(service, that.finalMenu, true);
                        })(that.services[i]);
                    }
                }
            }
        };

        that.accessLevelTranslate = function(value, noI18n) {
            if (noI18n) {
                for (var i in GUM_CONST.accessLevels) {
                    if (GUM_CONST.accessLevels[i] === value) {
                        return i;
                    }
                }
            }
            return $translate.instant('ACCESS_LEVEL_' + value, '', '', '');
        };

        that.onSliderChange = function() {
            trackingService.action('role.change_access_level');
        };
    }
})(window.angular);
